import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, signal, ViewChild } from '@angular/core';
import { IMPORTS } from './_imports';
import { AuthService } from '../../services/auth.service';
import { Enums } from '../../shared/enums';

@Component({
    selector: 'update-history',
    templateUrl: './update-history.component.html',
    styleUrl: './update-history.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class UpdateHistoryComponent implements OnInit, OnChanges {
    // #region [ViewChild]
    @ViewChild('pageContainerRef') pageContainerRef: ElementRef;
    // #endregion

    // #region [const]
    VISIBLE_WINDOW_IN_DAYS = 90 as const;
    // #endregion

    // #region [props]
    isAdminAll = false;
    // #endregion

    // #region [signals]
    $isModal = signal(false);
    // #endregion

    // #region [Input/Output]
    @Input() _isModal = false;
    @Output() _latestUpdateFoundEvent = new EventEmitter<string>();
    // #endregion

    constructor(private authService: AuthService) {
        if (this.authService.hasProfiles([Enums.Profiles.AdminAll])) {
            this.isAdminAll = true;
        }
    }

    ngOnInit() { }

    ngAfterViewInit() {
        this.applyVisibleWindowFilter();
        this.emitLatestId();
        this.checkEmptySections();
    }

    ngOnChanges() {
        this.$isModal.set(this._isModal);
    }

    
    // #region [===== private methods =====]
    // #endregion

    private applyVisibleWindowFilter() {
        if (!this.$isModal()) return;

        const entries = this.pageContainerRef.nativeElement.querySelectorAll('.entry');
        const savedId = localStorage.getItem(Enums.LocalStorageKeys.UpdateHistoryLastSeenId);

        const today = new Date();
        const limitDate = new Date();
        limitDate.setDate(today.getDate() - this.VISIBLE_WINDOW_IN_DAYS);

        entries.forEach((entry: Element) => {
            const id = entry.getAttribute('id');
            if (!id) return;

            const [dateString] = id.split('$');
            const entryDate = new Date(dateString);

            if (isNaN(entryDate.getTime())) return;

            if (entryDate < limitDate) {
                (entry as HTMLElement).remove();
            }

            if (savedId && id <= savedId) {
                (entry as HTMLElement).remove();
            }
        });
    }

    private emitLatestId() {
        const firstEntry = this.pageContainerRef.nativeElement.querySelector('.entry');
        if (firstEntry) {
            this._latestUpdateFoundEvent.emit(firstEntry.getAttribute('id'));
        }
    }

    private checkEmptySections() {
        const sections = this.pageContainerRef.nativeElement.querySelectorAll('.section');

        sections.forEach(section => {
            const visibleEntries = section.querySelectorAll('.entry');

            if (visibleEntries.length === 0) {
                (section as HTMLElement).remove();
            }
        });
    }
}
